module.exports = __webpack_public_path__ + "img/TraumIX_spreadYourTears.99fb493d.jpg";